<template>
	<div>
		<a-form-model  ref="addForm"  :model="meterModel"  :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" >
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="集中器" >
						<a-input  v-model="meterModel.GPRSAddr" :disabled="true"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="钢印号">
						<a-input  v-model="meterModel.SteelNum"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="铅封号">
						<a-input  v-model="meterModel.qfh"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="采集器" >
						<a-input  v-model="meterModel.CollectorAddr" />
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="表地址">
						<a-input  v-model="meterModel.MeterAddr"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="关联ID">
						<a-input  v-model="meterModel.APID" @blur="checkMeterExist(false)"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="管理表" >
						<a-select v-model="meterModel.MainMeter">
							<a-select-option v-for="(item,index) in mainMeterList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="10">
					<a-form-model-item label="供水方式">
						<a-select v-model="meterModel.SuppleMode">
							<a-select-option v-for="(item,index) in supplyModeList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="表类型" >
						<a-select v-model="meterModel.MeterKindID">
							<a-select-option v-for="(item,index) in meterKindList"  :value="item.PID" :key="item.PID">{{item.MeterTypeName}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="虚实表">
						<a-select v-model="meterModel.MeterSolid">
							<a-select-option v-for="(item,index) in solidList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="立户表">
						<a-select v-model="meterModel.Lihu">
							<a-select-option v-for="(item,index) in liHuList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="阀门">
						<a-select  v-model="meterModel.IsValve">
							<a-select-option v-for="(item,index) in hasList" :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="有阀扣费方式" :label-col="{ span: 10 }" :wrapper-col="{ span: 13 }" >
						<a-input v-model="meterModel.DeductionStyle== 1 ? '抄表后结算' :'抄表后不结算'" :disabled="true"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="关阀余额" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" >
						<a-input-number  v-model="meterModel.ValveOFFThre"  :min="0" :precision="0" style="width:8.8rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="定时检测" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterModel.TimerSwitch" @change="timerSwitchChange">
							<a-select-option v-for="(item,index) in openList" :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="定时时间"  :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
						<a-input-number v-model="meterModel.Timer" :disabled="theMeter.TimerSwitch == 0"  :min="1" :max="60" :precision="0" style="width:9.3rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="用量阀值"  :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
						<a-input-number v-model="meterModel.Overflow" :min="0" :precision="0" style="width:8.8rem;"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="8">
					<a-form-model-item label="水表类型" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterModel.type">
							<a-select-option value="10">10</a-select-option>
							<a-select-option value="11">11</a-select-option>
							<a-select-option value="12">12</a-select-option>
							<a-select-option value="0">0</a-select-option>
							<a-select-option value="1">1</a-select-option>
							<a-select-option value="2">2</a-select-option>
							<a-select-option value="3">3</a-select-option>
							<a-select-option value="5">5</a-select-option>
							<a-select-option value="8">8</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col :span="8">
					<a-form-model-item label="读数倍数" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
						<a-select  v-model="meterModel.multiple">
							<a-select-option value=1>1</a-select-option>
							<a-select-option value=10>10</a-select-option>
							<a-select-option value=100>100</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="checkMeterExist(true)">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'theMeter',
		],
		data(){
			return {
				submitFlag:false,
				mainMeterList:this.Config.getMainMeterList(),
				supplyModeList:this.Config.getSupplyModeList(),
				meterKindList:[],
				solidList:this.Config.getSolidList(),
				liHuList:this.Config.getLiHUList(),
				hasList:this.Config.getHasList(),
				openList:this.Config.getOpenList(),
				oldAPID:null,
				meterModel:null,
			}
		},
		methods:{
			onClose:function(){
				this.$emit('cancelEdit');
			},
			changeValve:function(checked,e){
				this.meterModel.IsValve = checked ? 1 : 0;
			},
			doValid:function(){
				if(this.meterModel.TimerSwitch == 1 && (this.meterModel.Timer == null || this.meterModel.Timer.length == 0||this.meterModel.Timer == undefined)){
					this.$message.error('请输入定时时间');
					return false;
				}
				return true;
			},
			onSubmit:function(){
				if(this.doValid()){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_UPDTAE_URL);
					this.Api.fetchPostWithJson(url,this.meterModel).then((data)=>{
						this.submitFlag  = false;
						let code = data.data.code;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.onClose();
							this.$message.success('修改成功');
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.submitFlag = false;
						console.log(error);
					});
				}
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_KIND_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.meterKindList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			timerSwitchChange:function(value,e){
				if(value !=1){
					this.meterModel.Timer = null;
				}
			},
			checkMeterExist:function(flag){
				if(flag){
					this.submitFlag = true;
				}
				console.log(this.meterModel.APID);
				if(this.oldAPID !=this.meterModel.APID && this.meterModel.APID){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_CHECK_EXIST_URL);
					let param = {APID:this.meterModel.APID};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(result == 1){
								this.$message.warning('关联ID已存在');
								if(flag && this.submitFlag == true){
									this.submitFlag = false;
								}
							}else{
								if(flag){
									this.onSubmit();
								}
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
					});
				}else{
					if(flag){
						this.onSubmit();
					}
				};
			},
		},
		created() {
			this.queryDataList();
			this.meterModel = this.Config.deepClone(this.theMeter); 
			this.oldAPID = this.Config.deepClone(this.meterModel.APID);
			let meterAddr = this.meterModel.MeterAddr;
			let array = meterAddr.split("(");
			if(array!=null && array.length>0){
				this.meterModel.MeterAddr = array[0];
			}else{
				this.meterModel.MeterAddr = meterAddr;
			}
			let collectorAddr = this.meterModel.CollectorAddr;
			let array1 = collectorAddr.split("(");
			if(array1!=null && array1.length>0){
				this.meterModel.CollectorAddr = array1[0];
			}else{
				this.meterModel.CollectorAddr = collectorAddr;
			}
		}
	}
</script>

<style>
</style>
